/**
 * M-27: Die zur AKTUELLEN Subdomain passende Mitgliedschaft waehlen statt blind memberships[0].
 * Bei Multi-Tenant-Nutzern entscheidet die Membership ueber sichtbare Owner/Admin-Controls und
 * den angezeigten Tenant - der Host (slug.maestro-app.de) ist die einzige verlaessliche Quelle
 * dafuer, "wo" der Nutzer gerade ist. Fallback memberships[0] nur, wenn kein Slug matcht
 * (z. B. lokale Dev-Hosts ohne Subdomain).
 */
import type { Me } from "../ui/types";

export function currentMembership(me: Me | undefined | null): Me["memberships"][number] | undefined {
  if (!me?.memberships.length) return undefined;
  const slug = window.location.hostname.split(".")[0];
  return me.memberships.find((m) => m.slug === slug) ?? me.memberships[0];
}
